export { ShareholderPage as default } from '@/components/pages/Ir/Investor/Shareholder'
